import React, { useState, memo } from "react";
import { Button } from "@mui/material";
import ExcelJS from "exceljs";
import moment from "moment-jalaali";
import Api from "../../../utils/api";
import { Loading } from "../../../components";
import { toast } from "react-toastify";

const MarketerQualified = ({ object, period_id }) => {
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await new Api().get(`/period/${period_id}/qualified`, object);
            const count = response?.data || 0;
            if (count > 0 && Array.isArray(response.data)) {
                const items = response.data;
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet("QualifiedMarketers");

                worksheet.columns = [
                    { header: "شناسه کاربر", key: "id", width: 15 },
                    { header: "نام", key: "full_name", width: 25 },
                    { header: "کد بازاریابی", key: "marketer_code", width: 20 },
                    { header: "شماره شبا", key: "shaba", width: 25 },
                    { header: "قرارداد بازاریابی", key: "contract", width: 20 },
                    { header: "مینتین", key: "maintain", width: 20 },
                ];

                items.forEach((item) => {
                    worksheet.addRow({
                        id: item.id,
                        full_name: item.full_name || '-',
                        marketer_code: item.marketer_code || '-',
                        shaba: item.shaba || '-',
                        contract: item.contract || '-',
                        maintain: item.maintain || '-',
                    });
                });

                worksheet.getRow(1).eachCell((cell) => {
                    cell.font = { bold: true, size: 14 };
                    cell.alignment = { horizontal: "center", vertical: "middle" };
                    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFCCEEFF" } };
                    cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
                });

                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber > 1) {
                        row.eachCell((cell) => {
                            cell.font = { size: 12 };
                            cell.alignment = { horizontal: "center", vertical: "middle" };
                        });
                    }
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const url = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `marketer_qualified_${period_id}_${moment().unix()}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } else {
                toast.error('رکوردی یافت نشد.');
            }
        } catch (error) {
            console.error("خطا در دریافت لیست واجدین:", error);
            toast.error('خطا در دریافت داده‌ها.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                size="small"
                variant="outlined"
                color="default"
                onClick={fetchData}
                disabled={loading}
            >
                واجدین دریافت پاداش
            </Button>
            {loading && <Loading />}
        </>
    );
};

export default memo(MarketerQualified);
